export default __webpack_public_path__ + "img/cCgAiTtA.34519019.svg";